module.exports = __webpack_public_path__ + "img/qr1.833f268e.jpg";